import amplitude, { AmplitudeClient } from 'amplitude-js'
import config from 'config'
import { UserProperties } from '.'

let amplitudeInstance: AmplitudeClient | undefined

export const init = () => {
  const { amplitudeId } = config.ANALYTICS

  if (amplitudeId) {
    amplitudeInstance = amplitude.getInstance()
    amplitudeInstance.init(amplitudeId, undefined, {
      serverZone: 'EU',
      serverZoneBasedApi: true,
      trackingOptions: {
        ip_address: false,
      },
    })
  }
}

export const disable = () => {
  amplitudeInstance = undefined
}

export const login = (userId: string, userProperties: UserProperties) => {
  amplitudeInstance?.setUserId(userId)
  amplitudeInstance?.setUserProperties(userProperties)
}

export const logout = () => {
  amplitudeInstance?.setUserId(null)
  amplitudeInstance?.clearUserProperties()
}

export const logEvent = (
  eventId: string,
  properties?: Record<string, unknown>
) => {
  amplitudeInstance?.logEvent(eventId, properties)
}
